import React, { useEffect, useState } from "react";
import Index from "../views/dashboard/index";
import { Navigate } from "react-router-dom";
import { isUserAuthenticated } from "../utilities/setting";
 
import { ROUTES } from "../utilities/constant";
 
// users
// import UserProfile from '../views/dashboard/app/user-profile';
import UserAdd from "../views/dashboard/app/user-add";
import UserEdit from "../views/dashboard/app/user-edit";
import UserList from "../views/dashboard/app/user-list";
import AgentFileList from "../views/dashboard/manage-agents/agent_file_list";
 
//Company
import CompanyList from "../views/dashboard/company/list";
import CompanyUpdate from "../views/dashboard/company/edit";
import CompanyCreate from "../views/dashboard/company/create";
 
//Call Centre
import CallCentreList from "../views/dashboard/call-centre/list";
import CallCentreCreate from "../views/dashboard/call-centre/create";
import CallCentreUpdate from "../views/dashboard/call-centre/edit";
import CallCentreUsersList from "../views/dashboard/call-centre/user-list";
import CallCentreUserCreate from "../views/dashboard/call-centre/user-add";
import CallCentreUserEdit from "../views/dashboard/call-centre/user-edit";
import ErrorPage from "../views/dashboard/errors/error500.js";
 
//Trunks
import { TrunkCreate, TrunkList, TrunkEdit } from "../views/dashboard/trunks";
import {
  DataCenterList,
  DataCenterCreate,
  DataCenterEdit,
} from "../views/dashboard/data-center";
 
//IVR
import IvrList from "../views/dashboard/ivr/IVR/ivr_list";
import IvrView from "../views/dashboard/ivr/IVR/ivr_view";
import IvrCreate from "../views/dashboard/ivr/IVR/create"
import IvrEdit from "../views/dashboard/ivr/IVR/edit"
 
import CreditHistory from "../views/dashboard/credit-history/list";
import CreditSummary from "../views/dashboard/credit-history/summary";
import IncomingSummary from "../views/dashboard/incoming-summary/list"
import OutcomingSummary from "../views/dashboard/outcoming-summary/list"
import ViewDetail from "../views/dashboard/incoming-summary/view-detail"
import DownloadReport from "../views/dashboard/incoming-summary/download-report"
import BackendLogs from "../views/dashboard/backend-logs/list";
 
 
import CreateGroup from "../views/dashboard/manage-groups/createGroup"
 
 
// import userProfileEdit from '../views/dashboard/app/user-privacy-setting';
 
//admin
// import Admin from '../views/dashboard/admin/admin';
import DefaultRouter1 from "./default-router1";
import DefaultTemp from "../layouts/dashboard/default-temp";
import UserAllocate from "../views/dashboard/app/user-allocate";
 
//Numbers
import {
  NumbersCreate,
  NumbersList,
  NumbersEdit,
  NumberFileList,
  StatusChangeActionList
} from "../views/dashboard/numbers";
 
//server-management
import {
  ServerManagementCreate,
  ServerManagementEdit,
  ServerManagementList,
} from "../views/dashboard/server-management";
 
//Voice-plan
import {
  VoicePlanCreate,
  VoicePlanList,
} from "../views/dashboard/voice-plan";
 
//flash-message
import {
  FlashMessageCreate,
  FlashMessageList,
} from "../views/dashboard/flash-message";
 
//realtime
import RealTimeList from "../views/dashboard/Realtime/list";
 
import DIDHistory from "../views/dashboard/did-history/list";
 
 
import {AgentGroups, CreateAgent, Extension} from '../views/dashboard/manage-agents'
import {RemarkStatusList, RemarkStatusCreate, RemarkStatusEdit, Remarks} from '../views/dashboard/remarks'
import {Agents, EditAgent} from '../views/dashboard/manage-agents'
 
//module
import { ModuleCreate,ModuleList,ModuleEdit, ACLSettingEdit, ACLSettingList, ACLSettingCreate } from "../views/dashboard/module";
import JourneyOperationList from "../views/dashboard/journey-operation/list";
import CreateAgentGroups from "../views/dashboard/manage-agents/createAgentGroups";
import CreateExtension from "../views/dashboard/manage-agents/createExtension";
import BulkCreateExtension from "../views/dashboard/manage-agents/BulkCreateExtension";
import { Queues } from "../views/manage-queues";
import GroupSettings from "../views/dashboard/manage-agents/groupSettings";
import AddVoice from "../views/dashboard/ivr/voice-library/add-voice";
import ViewVoice from "../views/dashboard/ivr/voice-library/view-voice";
import { ManagePrompts, MohManagement, AddMoh } from "../views/dashboard/voice-library";
import Tts from "../views/dashboard/voice-library/View-voice-files";
import InboundCalls from '../views/dashboard/ivr/inbound-calls/inboundCalls'
import UserResetPassword from "../views/dashboard/app/user-reset-pass";
import UpdateInboundCalls from "../views/dashboard/ivr/inbound-calls/inbound-calls-edit";
import CampaignsList from "../views/dashboard/campaigns/list";
import CreateCampaign from "../views/dashboard/campaigns/create";
import CampaignDetail from "../views/dashboard/campaigns/detail";
// import Add from "../views/dashboard/desposition/add";
 
import BreakList from "../views/dashboard/breaks/list";
import CreateBreak from "../views/dashboard/breaks/create";
import UpdateBreak from "../views/dashboard/breaks/edit";
 
import SmsWebhookList from "../views/dashboard/sms-webhook/list";
import CreateSmsWebhook from "../views/dashboard/sms-webhook/create";
import UpdateSmsWebhook from "../views/dashboard/sms-webhook/edit";

import ApiWebhookList from "../views/dashboard/api-webhook/list";
import CreateApiWebhook from "../views/dashboard/api-webhook/create";
import UpdateApiWebhook from "../views/dashboard/api-webhook/edit";
 
import ManageWebhookList from "../views/dashboard/manage-webhook/list";
import CreateManageWebhook from "../views/dashboard/manage-webhook/create";
import UserProfilePage from "../views/dashboard/app/user-profile-page";
 
import ContactGroupList from "../views/dashboard/contact-group/list";
import CreateContactGroup from "../views/dashboard/contact-group/create";
import UpdateContactGroup from "../views/dashboard/contact-group/edit";
import ImportContactGroupMembers from "../views/dashboard/contact-group/import-members";
import AllContacts from "../views/dashboard/contact-group/all-contacts";
import CreateAllContacts from "../views/dashboard/contact-group/create-all-contacts";
import GroupList from "../views/dashboard/manage-groups/groupListing";
import CreateLocation from "../views/dashboard/manage-locations/createLocation";
import LocationListing from "../views/dashboard/manage-locations/locationListing";
import CountryCodeDirectionsList from "../views/dashboard/country-code-directions/list";
import CountryCodeDirectionForm from "../views/dashboard/country-code-directions/form";
import CreateDialer from "../views/dashboard/manage-dialers/createDialer";
import DialerListing from "../views/dashboard/manage-dialers/dialerListing";
import BulkGroupAdd from "../views/dashboard/manage-groups/BulkGroupAdd";
import BulkGroupDelete from "../views/dashboard/manage-groups/BulkGroupDelete";
import BulkLocationAdd from "../views/dashboard/manage-locations/BulkLocationAdd";
import BulkLocationDelete from "../views/dashboard/manage-locations/BulkLocationDelete";
import AddTts from "../views/dashboard/tts/add-tts";
import TtsList from "../views/dashboard/tts/tts-list";
import TtsPlanList from "../views/dashboard/tts-plans/list";
import AddTtsPlans from "../views/dashboard/tts-plans/add";
import LicenceHistoryList from "../views/dashboard/licence_history/list";
import { AgentAnnouncementCreate, AgentAnnouncementEdit, AgentAnnouncementList } from "../views/dashboard/agent-announcement";
import { AgentIdleStatsList } from "../views/dashboard/agent-idle-stats";
import NotificationList from "../views/dashboard/notification/notification_list";
import NotificationCreate from "../views/dashboard/notification/notification_create";
import NotificationEdit from "../views/dashboard/notification/notification_edit";
import NotificationAssignments from "../views/dashboard/notification/notification_assignments";
 import { DispositionFormsCreate, DispositionFormsEdit, DispositionFormsList } from "../views/dashboard/disposition-forms";
import CdrReport from "../views/dashboard/incoming-summary/cdr-report";
import CallScriptList from "../views/dashboard/scripts/CallScriptList";
import CallScriptCreate from "../views/dashboard/scripts/CallScriptCreate";
import CallScriptEdit from "../views/dashboard/scripts/CallScriptEdit";
// import path from "path";
import VoicePlanEdit from "../views/dashboard/voice-plan/edit";

export const DefaultRouter = async () => {
 
  const defaultRouter = [
    {
      path: "/",
      element: <DefaultRouter1 />,
      children: [
        {
          path: "/",
          element: <Navigate to={ROUTES.DASHBOARD} replace />,
        },
        {
          path: ROUTES.DASHBOARD,
          element: <Index />,
        },
        {
          path: ROUTES.USERS.EDIT,
          element: <UserEdit />,
        },
        {
          path: ROUTES.USERS.RESET_PASSWORD,
          element: <UserResetPassword />,
        },
        {
          path: ROUTES.USERS.CREATE,
          element: <UserAdd />,
        },
        {
          path: ROUTES.USERS.LIST,
          element: <UserList />,
        },
        {
          path: ROUTES.COMPANIES.LIST,
          element: <CompanyList />,
        },
        {
          path: ROUTES.COMPANIES.EDIT,
          element: <CompanyUpdate />,
        },
        {
          path: ROUTES.COMPANIES.CREATE,
          element: <CompanyCreate />,
        },
        {
          path: ROUTES.CALL_CENTRES.CREATE,
          element: <CallCentreCreate />,
        },
        {
          path: ROUTES.CALL_CENTRES.LIST,
          element: <CallCentreList />,
        },
        {
          path: ROUTES.CALL_CENTRES.EDIT,
          element: <CallCentreUpdate />,
        },
        {
          path: ROUTES.CALL_CENTRES.USERS.LIST,
          element: <CallCentreUsersList />,
        },
        {
          path: ROUTES.CALL_CENTRES.USERS.CREATE,
          element: <CallCentreUserCreate />,
        },
        {
          path: ROUTES.CALL_CENTRES.USERS.EDIT,
          element: <CallCentreUserEdit />,
        },
        {
          path: ROUTES.TRUNKS.CREATE,
          element: <TrunkCreate />,
        },
        {
          path: ROUTES.TRUNKS.LIST,
          element: <TrunkList />,
        },
        {
          path: ROUTES.TRUNKS.EDIT,
          element: <TrunkEdit />,
        },
        {
          path: ROUTES.NUMBERS.CREATE,
          element: <NumbersCreate />,
        },
        {
          path: ROUTES.NUMBERS.LIST,
          element: <NumbersList />,
        },
        {
          path: ROUTES.NUMBERS.EDIT,
          element: <NumbersEdit />,
        },
        {
          path: ROUTES.NUMBERS.NUMBER_FILE_LIST,
          element: <NumberFileList />,
        },
        {
          path: ROUTES.NUMBERS.STATUS_CHANGE_ACTION,
          element: <StatusChangeActionList />,
        },
        {
          path: ROUTES.NUMBERS.DID_MAPPING,
          element: <UserList />,
        },
        {
          path: ROUTES.IVR.CREATE,
          element: <IvrCreate />,
        },
        {
          path: ROUTES.IVR.LIST,
          element: <IvrList />,
        },
        {
          path: ROUTES.IVR.EDIT,
          element: <IvrEdit />,
        },
        {
          path: ROUTES.IVR.VIEW,
          element: <IvrView />,
        },
        {
          path: ROUTES.DATA_CENTER.CREATE,
          element: <DataCenterCreate />,
        },
        {
          path: ROUTES.DATA_CENTER.LIST,
          element: <DataCenterList />,
        },
        {
          path: ROUTES.DATA_CENTER.EDIT,
          element: <DataCenterEdit />,
        },
        {
          path: ROUTES.SERVER_MANAGEMENT.CREATE,
          element: <ServerManagementCreate />,
        },
        {
          path: ROUTES.SERVER_MANAGEMENT.LIST,
          element: <ServerManagementList />,
        },
        {
          path: ROUTES.SERVER_MANAGEMENT.EDIT,
          element: <ServerManagementEdit />,
        },
        {
          path: ROUTES.MODULE.CREATE,
          element: <ModuleCreate />,
        },
        {
          path: ROUTES.MODULE.LIST,
          element: <ModuleList />,
        },
        {
          path: ROUTES.MODULE.EDIT,
          element: <ModuleEdit />,
        },
        {
          path: ROUTES.ACL_SETTING.CREATE,
          element: <ACLSettingCreate />,
        },
        {
          path: ROUTES.ACL_SETTING.LIST,
          element: <ACLSettingList />,
        },
        {
          path: ROUTES.ACL_SETTING.EDIT,
          element: <ACLSettingEdit />,
        },
        {
          path: ROUTES.JOURNEY_OPERATION.LIST,
          element: < JourneyOperationList/>,
        },
        {
          path: ROUTES.MANAGE_AGENTS.CREATE_AGENT,
          element: <CreateAgent/>,
        },
        {
          path: ROUTES.MANAGE_AGENTS.AGENTS,
          element: <Agents/>,
        },
        {
          path: ROUTES.MANAGE_AGENTS.AGENT_GROUP_LIST,
          element: <AgentGroups/>,
        },
        {
          path: ROUTES.MANAGE_AGENTS.CREATE_AGENT_GROUP,
          element: <CreateAgentGroups/>,
        },
        {
          path: ROUTES.MANAGE_AGENTS.EXTENSION,
          element: <Extension/>,
        },
        {
          path: ROUTES.MANAGE_AGENTS.CREATE_EXTENSION,
          element: <CreateExtension/>,
        },
        {
          path: ROUTES.MANAGE_AGENTS.BULK_CREATE_EXTENSION,
          element: <BulkCreateExtension/>,
        },
        {
          path: ROUTES.MANAGE_AGENTS.EDIT_EXTENSION,
          element: <CreateExtension/>,
        },
        {
          path: ROUTES.MANAGE_QUEUES.QUEUES,
          element: <Queues/>,
        },
        {
          path: ROUTES.USERS.RESELLERALLOCATE,
          element: < UserAllocate/>,
        },
        {
          path: ROUTES.MANAGE_AGENTS.GROUP_SETTINGS,
          element: < GroupSettings/>,
        },
        {
          path: ROUTES.MANAGE_AGENTS.AGENT_FILE_LIST,
          element: <AgentFileList />,
        },
        {
          path: ROUTES.IVR.ADD_VOICE,
          element: < AddVoice/>,
        },
        {
          path: ROUTES.VOICE_LIBRARY.MANAGE_PROMPTS,
          element: < ManagePrompts/>,
        },
        {
          path: ROUTES.VOICE_LIBRARY.MOH_MANAGEMENT,
          element: <MohManagement/>,
        },
        {
          path: ROUTES.VOICE_LIBRARY.ADD_MOH,
          element: <AddMoh/>,
        },
        {
          path: ROUTES.IVR.VIEW_VOICE,
          element: < ViewVoice/>,
        },
        {
          path: ROUTES.VOICE_LIBRARY.VIEW_VOICE_FILES,
          element: < Tts/>,
        },
        {
          path: ROUTES.IVR.INBOUND_CALLS,
          element: < InboundCalls/>,
        },
        {
          path: ROUTES.IVR.UPDATE_INBOUND_CALLS,
          element: < UpdateInboundCalls/>,
        },
        {
          path: ROUTES.CAMPAIGNS.LIST,
          element: <CampaignsList/>,
        },
        {
          path: ROUTES.CAMPAIGNS.CREATE,
          element: <CreateCampaign/>,
        },
        {
          path: ROUTES.CAMPAIGNS.DUPLICATE,
          element: <CreateCampaign/>,
        },
        {
          path: ROUTES.CAMPAIGNS.DETAIL,
          element: <CampaignDetail/>,
        },
        {
          path: ROUTES.BREAKS.LIST,
          element: <BreakList/>,
        },
        {
          path: ROUTES.BREAKS.CREATE,
          element: <CreateBreak/>,
        },
        {
          path: ROUTES.BREAKS.UPDATE,
          element: <UpdateBreak/>,
        },
        {
          path: ROUTES.SMSWEBHOOK.LIST,
          element: <SmsWebhookList/>,
         },
         {
          path: ROUTES.SMSWEBHOOK.CREATE,
          element: <CreateSmsWebhook/>,
         },
         {
          path: ROUTES.SMSWEBHOOK.UPDATE,
          element: <UpdateSmsWebhook/>,
         },
         {
          path: ROUTES.APIWEBHOOK.LIST,
          element: <ApiWebhookList/>,
         },
         {
          path: ROUTES.APIWEBHOOK.CREATE,
          element: <CreateApiWebhook/>,
         },
         {
          path: ROUTES.APIWEBHOOK.UPDATE,
          element: <UpdateApiWebhook/>,
         },

         {
          path: ROUTES.MANAGE_WEBHOOK.LIST,
          element: <ManageWebhookList/>,
         },
         {
          path: ROUTES.MANAGE_WEBHOOK.CREATE,
          element: <CreateManageWebhook/>,
         },
         {
          path: ROUTES.MANAGE_WEBHOOK.EDIT,
          element: <CreateManageWebhook/>,
         },
         {
          path: ROUTES.PROFILE,
          element: <UserProfilePage/>,
         },
         {
          path: ROUTES.CONTACTGROUP.LIST,
          element: <ContactGroupList/>,
        },
        {
          path: ROUTES.MANAGE_GROUPS.CREATE,
          element: <CreateGroup/>,
        },
        {
          path: ROUTES.MANAGE_GROUPS.GROUP_LIST,
          element: <GroupList/>,
        },
        {
          path: ROUTES.MANAGE_GROUPS.BULK_ADD,
          element: <BulkGroupAdd/>,
        },
        {
          path: ROUTES.MANAGE_GROUPS.BULK_DELETE,
          element: <BulkGroupDelete/>,
        },
        {
          path: ROUTES.MANAGE_LOCATIONS.CREATE,
          element: <CreateLocation/>,
        },
        {
          path: ROUTES.MANAGE_LOCATIONS.LOCATION_LIST,
          element: <LocationListing/>,
        },
        {
          path: ROUTES.MANAGE_LOCATIONS.BULK_ADD,
          element: <BulkLocationAdd/>,
        },
        {
          path: ROUTES.MANAGE_LOCATIONS.BULK_DELETE,
          element: <BulkLocationDelete/>,
        },
        {
          path: ROUTES.COUNTRY_CODE_DIRECTIONS.LIST,
          element: <CountryCodeDirectionsList/>,
        },
        {
          path: ROUTES.COUNTRY_CODE_DIRECTIONS.CREATE,
          element: <CountryCodeDirectionForm isEdit={false}/>,
        },
        {
          path: ROUTES.COUNTRY_CODE_DIRECTIONS.EDIT,
          element: <CountryCodeDirectionForm isEdit={true}/>,
        },
        {
          path: ROUTES.TTS.CREATE,
          element: <AddTts/>,
        },
        {
          path: ROUTES.TTS.LIST,
          element: <TtsList/>,
        },
        {
          path: ROUTES.TTSPLANS.CREATE,
          element: <AddTtsPlans/>,
        },
        {
          path: ROUTES.TTSPLANS.LIST,
          element: <TtsPlanList/>,
        },
        {
          path: ROUTES.MANAGE_DIALERS.CREATE,
          element: <CreateDialer/>,
        },
        {
  path: ROUTES.MANAGE_DIALERS.EDIT,  
  element: <CreateDialer />,
},
{
          path: ROUTES.MANAGE_AGENTS.AGENT_FILE_LIST,
          element: <AgentFileList />,
        },
 
        {
          path: ROUTES.MANAGE_AGENTS.EDIT_EXTENSION,
          element: <CreateExtension/>,
        },
 
 
        {
          path: ROUTES.MANAGE_DIALERS.DIALER_LISTING,
          element: <DialerListing/>,
        },
        {
          path: ROUTES.CONTACTGROUP.CREATE,
          element: <CreateContactGroup/>,
        },
        {
          path: ROUTES.CONTACTGROUP.UPDATE,
          element: <UpdateContactGroup/>,
        },
        {
          path: ROUTES.CONTACTGROUP.IMPORT_MEMBERS,
          element: <ImportContactGroupMembers/>,
        },
        {
          path: ROUTES.CONTACTGROUP.ALL_CONTACTS,
          element: <AllContacts/>,
        },
        {
          path: ROUTES.CONTACTGROUP.CREATE_ALL_CONTACTS,
          element: <CreateAllContacts/>,
        },
        {
          path: ROUTES.CREDIT_HISTORY,
          element: < CreditHistory/>,
        },
        {
          path: ROUTES.CREDIT_SUMMARY,
          element: <CreditSummary/>,
        },
        {
          path: ROUTES.IVR.INCOMING_SUMMARY,
          element: <IncomingSummary />
        },
        {
          path: ROUTES.IVR.OUTCOMING_SUMMARY,
          element: <OutcomingSummary />
        },
        {
          path: ROUTES.IVR.VIEW_DETAIL,
          element: <ViewDetail />
        },
        {
          path: ROUTES.IVR.DOWNLOAD_REPORT,
          element: <DownloadReport />
        },
        {
          path: ROUTES.IVR.CDR_REPORT,
          element: <CdrReport />
        },
        {
          path: ROUTES.MANAGE_AGENTS.EDIT_AGENT,
          element: <EditAgent />
        },
        {
          path: ROUTES.VOICE_PLAN.LIST,
          element: <VoicePlanList />
        },
        {
          path: ROUTES.VOICE_PLAN.CREATE,
          element: <VoicePlanCreate />
        },
        {
          path: ROUTES.VOICE_PLAN.EDIT,
          element: <VoicePlanEdit />
        },
        {
          path: ROUTES.FLASH_MESSAGE.LIST,
          element: <FlashMessageList />
        },
        {
          path: ROUTES.FLASH_MESSAGE.CREATE,
          element: <FlashMessageCreate />
        },
        {
          path: ROUTES.REALTIME.LIST,
          element: <RealTimeList />
        },
        {
          path: ROUTES.NUMBERS.DID_HISTORY,
          element: <DIDHistory />
        },
        {
          path: ROUTES.REMARKS.LIST,
          element: <RemarkStatusList />
        },
        {
          path: ROUTES.REMARKS.EDIT,
          element: <RemarkStatusEdit />
        },
        {
          path: ROUTES.REMARKS.ADD,
          element: <RemarkStatusCreate />
        },
        {
          path: ROUTES.REMARKS.REMARKS,
          element: <Remarks />
        },
        {
          path: ROUTES.DISPOSITION_FORMS.LIST,
          element: <DispositionFormsList />
        },
        {
          path: ROUTES.DISPOSITION_FORMS.CREATE,
          element: <DispositionFormsCreate />
        },
        {
          path: ROUTES.DISPOSITION_FORMS.EDIT,
          element: <DispositionFormsEdit />
        },
 

        // --- Agent Announcement Routes ---
        {
          path: ROUTES.AGENT_ANNOUNCEMENT.LIST,
          element: <AgentAnnouncementList />
        },
        {
          path: ROUTES.AGENT_ANNOUNCEMENT.CREATE,
          element: <AgentAnnouncementCreate />
        },
        {
          path: ROUTES.AGENT_ANNOUNCEMENT.EDIT,
          element: <AgentAnnouncementEdit />
        },


        // call script routes

        {
          path: ROUTES.CALL_SCRIPT.LIST,
          element: <CallScriptList />
        },
        {
          path: ROUTES.CALL_SCRIPT.CREATE,
          element: <CallScriptCreate />
        },
        {
          path: ROUTES.CALL_SCRIPT.EDIT,
          element: <CallScriptEdit />
        },


        {
          path: ROUTES.AGENT_IDLE_STATS.LIST,
          element: <AgentIdleStatsList />
        },
        {
          path: ROUTES.LICENCE_HISTORY.LIST,
          element: <LicenceHistoryList />
        },
        {
          path: ROUTES.BACKEND_LOGS,
          element: <BackendLogs/>,
        },


 // --- Notification Routes ---
        {
          path: ROUTES.NOTIFICATION.LIST,
          element: <NotificationList />
        },
        {
          path: ROUTES.NOTIFICATION.CREATE,
          element: <NotificationCreate />
        },
        {
          path: ROUTES.NOTIFICATION.EDIT,
          element: <NotificationEdit />
        },
        {
          path: ROUTES.NOTIFICATION.ASSIGNMENTS,
          element: <NotificationAssignments />
        },

        {
          path: "*",
          element: <ErrorPage />
        }
        // {
        //   path: ROUTES.DESPOSITION.ADD,
        //   element: <Add/>
        // },
 
      ],
    },
  ];
 
  return defaultRouter;
};
 
// const DefaultRouter = () => {
//     return (
//         <TransitionGroup>
//             {/* <CSSTransition classNames="fadein" timeout={300}> */}
//                 <Switch>
//                     <Route path="/dashboard" exact component={userAuthenticated ? Index : navigateToLogin} />
//                     {/* user */}
//                     <Route path="/dashboard/app/user-profile"     exact component={UserProfile} />
//                     <Route path="/dashboard/app/user-add"         exact component={UserAdd}/>
//                     <Route path="/dashboard/app/user-list"        exact component={UserList}/>
//                     <Route path="/dashboard/app/user-privacy-setting" exact component={userProfileEdit}/>
//                      {/* widget */}
//                      <Route path="/dashboard/widget/widgetbasic"   exact component={Widgetbasic}/>
//                      <Route path="/dashboard/widget/widgetcard"    exact component={Widgetcard}/>
//                      <Route path="/dashboard/widget/widgetchart"   exact component={Widgetchart}/>
//                      {/* icon */}
//                      <Route path="/dashboard/icon/solid"           exact component={Solid}/>
//                      <Route path="/dashboard/icon/outline"         exact component={Outline}/>
//                      <Route path="/dashboard/icon/dual-tone"       exact component={DualTone}/>
//                      {/* From */}
//                      <Route path="/dashboard/form/form-element"    exact component={FormElement}/>
//                      <Route path="/dashboard/form/form-validation" exact component={FormValidation}/>
//                      <Route path="/dashboard/form/form-wizard"     exact component={FormWizard}/>
//                      {/* table */}
//                      <Route path="/dashboard/table/bootstrap-table" exact component={BootstrapTable}/>
//                      <Route path="/dashboard/table/table-data"      exact component={TableData}/>
//                      {/*special pages */}
//                      <Route path="/dashboard/special-pages/billing" exact component={Billing}/>
//                      <Route path="/dashboard/special-pages/kanban" exact component={Kanban}/>
//                      <Route path="/dashboard/special-pages/pricing" exact component={Pricing}/>
//                      <Route path="/dashboard/special-pages/timeline" exact component={Timeline}/>
//                      <Route path="/dashboard/special-pages/calender" exact component={Calender}/>
//                      {/* map */}
//                      <Route path="/dashboard/map/vector" exact component={Vector}/>
//                      <Route path="/dashboard/map/google" exact component={Google}/>
//                      {/* extra */}
//                      <Route path="/dashboard/extra/privacy-policy" exact component={PrivacyPolicy}/>
//                      <Route path="/dashboard/extra/terms-of-service" exact component={TermsofService}/>
//                      {/*admin*/}
//                      <Route path="/dashboard/admin/admin" exact component={Admin}/>
//                 </Switch>
//             {/* </CSSTransition> */}
//         </TransitionGroup>
//     )
// }
 
// export { DefaultRouter }
 